type SortableValue = string | number | boolean | null | undefined;

const isEmptyValue = (value: SortableValue) =>
  value === null || value === undefined || value === "";

const compareNonEmptyValues = (a: SortableValue, b: SortableValue) => {
  if (typeof a === "number" && typeof b === "number") {
    return a - b;
  }
  if (typeof a === "boolean" && typeof b === "boolean") {
    return Number(a) - Number(b);
  }
  return String(a).localeCompare(String(b), undefined, { numeric: true });
};

export const compareWithEmptyValuesLast = (
  a: SortableValue,
  b: SortableValue,
  desc: boolean
) => {
  const aEmpty = isEmptyValue(a);
  const bEmpty = isEmptyValue(b);
  if (aEmpty && bEmpty) {
    return 0;
  }
  if (aEmpty) {
    return 1;
  }
  if (bEmpty) {
    return -1;
  }
  const result = compareNonEmptyValues(a, b);
  return desc ? -result : result;
};

export const sortWithEmptyValuesLast = <TItem>(
  items: Array<TItem>,
  valueResolver: ((item: TItem) => unknown) | undefined,
  desc: boolean
): Array<TItem> => {
  if (!valueResolver) {
    return items;
  }
  return [...items].sort((a, b) =>
    compareWithEmptyValuesLast(
      valueResolver(a) as SortableValue,
      valueResolver(b) as SortableValue,
      desc
    )
  );
};
